import env from '../../../networkRequests/apiClient/env.config'
import { UspsLocation } from '../../../redux/states/usps/getUspsLocations/getUspsLocations.types'

export type LocationCacheEntry = { locations: UspsLocation[]; errorMessage: string | null }

export const locationsCache = new Map<string, LocationCacheEntry>()

export const getCacheKey = (zipCode: string, radius: number): string => `${zipCode}-${radius}`

/** Same shapes as {@link buildUspsZipCodeForAddressRequest}: 5-digit ZIP or hyphenated ZIP+4. */
export function isUnitedStatesPostalCodeOrZipPlus4(postalCode: string | undefined | null): boolean {
  const trimmedPostalCode = postalCode?.trim() ?? ''

  return /^\d{5}(-\d{4})?$/.test(trimmedPostalCode)
}

/** 5-digit ZIP or 9-digit `12345-6789` for USPS validate-address / label alignment. */
export function buildUspsZipCodeForAddressRequest(location: Pick<UspsLocation, 'zipCode' | 'zipPlus4'>): string {
  const plusDigits = location.zipPlus4?.replace(/\D/g, '').slice(0, 4) ?? ''

  if (plusDigits.length === 4) {
    return `${location.zipCode}-${plusDigits}`
  }

  return location.zipCode
}

export const defaultRadiusMiles = (): number => {
  const value = env.USPS_LOCATION_SEARCH_RADIUS_MILES
  const parsed = Number(value)

  return Number.isFinite(parsed) ? parsed : 10
}
